import { gql } from "@apollo/client";

export const EXPORT_DOCUMENT = gql`
  mutation exportDocument($input: ExportDocumentInput!) {
    exportDocument(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_DOCUMENTS = gql`
  mutation exportDocuments($input: ExportDocumentsInput!) {
    exportDocuments(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const START_DOCUMENTS_SIGNING = gql`
  mutation startDocumentsSigning($input: StartDocumentsSigningInput!) {
    startDocumentsSigning(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RESET_DOCUMENT_SIGNING = gql`
  mutation resetDocumentSigning($input: ResetDocumentSigningInput!) {
    resetDocumentSigning(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const RETRIEVE_PRINTS = gql`
  mutation retrieveDocumentPrints($input: RetrieveDocumentPrintsInput!) {
    retrieveDocumentPrints(input: $input) {
      commandId
      correlationId
    }
  }
`;
